import { defineComponent as l, computed as e } from "vue";
import m from "./td-longtail-vue-components75.js";
import c from "./td-longtail-vue-components74.js";
const i = /* @__PURE__ */ l({
  __name: "charger",
  props: {
    chargerIncluded: { type: Boolean, default: null },
    pd: { type: Boolean, default: null },
    watts: { type: String, default: null },
    commonCharger: {
      type: Object,
      default: null
    }
  },
  setup(t) {
    const r = t, n = e(() => r.commonCharger ? r.commonCharger.possible === !0 : !0), o = e(() => r.chargerIncluded !== null ? r.chargerIncluded : r.commonCharger?.included === !0 ? !0 : r.commonCharger?.included === !1 ? !1 : null), a = e(() => r.pd ? r.pd : r.commonCharger?.usbPd === !0 ? !0 : (r.commonCharger?.usbPd === !1, !1)), u = e(() => r.watts ? r.watts : r.commonCharger?.minWattage || r.commonCharger?.maxWattage ? [r.commonCharger.minWattage, r.commonCharger.maxWattage].filter(Boolean).join("-") : null);
    return { __sfc: !0, props: r, isPossible: n, isIncluded: o, hasPd: a, wattsText: u, ChargerBox: m, ChargerLabel: c };
  }
});
export {
  i as default
};
